import { computed } from "vue";
// utils/useConfirmAction.js
import Swal from "sweetalert2";

const useUtil = () => {
  const appEnv = process.env.VUE_APP_ENV;
  const numberFormat = (numero) => {
    return numero.toLocaleString("es-MX", {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    });
  };

  const baseURL = computed(() => {
    return appEnv === "production"
      ? process.env.VUE_APP_ENDPOINT_SERVER
      : process.env.VUE_APP_ENDPOINT_LOCAL;
  });

  const valorAPorcentaje = (numero) => {
    return numero / 100;
  };

  const porcentajeAValor = (porcentaje) => {
    return Math.round(porcentaje * 100);
  };

  const edate = (date, months, retYear) => {
    const d = new Date(date);
    const newMonth = d.getMonth() + months;
    d.setMonth(newMonth);

    if (d.getDate() !== new Date(date).getDate()) {
      d.setDate(0);
    }

    const day = d.getDate().toString().padStart(2, "0");
    const month = d.toLocaleString("es-ES", { month: "long" });
    const year = d.getFullYear().toString().slice(-2); // últimos 2 dígitos

    if (retYear) return year;

    return `${day} ${month.charAt(0).toUpperCase() + month.slice(1)} ${year}`;
  };

  const formatoMoneda = (numero, redondeado = true) => {
    if (numero == null || numero === "") return null;

    const valor = Number(numero);
    if (isNaN(valor)) return null;

    return valor.toLocaleString("en-US", {
      minimumFractionDigits: redondeado ? 0 : 2,
      maximumFractionDigits: redondeado ? 0 : 2,
    });
  };

  const obtenerFechaActual = () => {
    const hoy = new Date();
    return formatearFecha(hoy);
  };

  const agregarDias = (fecha, dias) => {
    const partes = fecha.split("/");
    const dia = parseInt(partes[0], 10);
    const mes = parseInt(partes[1], 10) - 1; // Meses en JS van de 0 a 11
    const anio = parseInt(partes[2], 10);

    const fechaObj = new Date(anio, mes, dia);
    fechaObj.setDate(fechaObj.getDate() + dias);

    return formatearFecha(fechaObj);
  };

  const formatearFecha = (fecha) => {
    const dia = String(fecha.getDate()).padStart(2, "0");
    const mes = String(fecha.getMonth() + 1).padStart(2, "0"); // Mes +1
    const anio = fecha.getFullYear();
    return `${dia}/${mes}/${anio}`;
  };

  const confirmAction = async ({
    title = "¿Desea continuar?",
    html = "Verifique sus datos.<br>Esta acción <b>no se podrá deshacer</b>.",
    icon = "question",
    confirmButtonText = "Confirmar",
    cancelButtonText = "Cancelar",
    confirmButtonClass = "btn bg-gradient-primary mx-2",
    cancelButtonClass = "btn bg-gradient-light",
  } = {}) => {
    const result = await Swal.fire({
      title,
      html,
      icon,
      showCancelButton: true,
      confirmButtonColor: "#0E49B0FF",
      cancelButtonColor: "#EF2525FF",
      confirmButtonText,
      cancelButtonText,
      reverseButtons: true,
      focusCancel: true,
      customClass: {
        confirmButton: confirmButtonClass,
        cancelButton: cancelButtonClass,
      },
      buttonsStyling: false, //
    });

    return result.isConfirmed;
  };

  const capitalizarTexto = (texto) => {
    return texto
      .toLowerCase()
      .replace(/\b\w/g, (letra) => letra.toUpperCase())
      .trim();
  };

  // "https://ventus.devratio.com.mx/api/public/api/"

  const urlEndpoint =
    process.env.VUE_APP_ENV == "production"
      ? process.env.VUE_APP_ENDPOINT_SERVER
      : process.env.VUE_APP_ENDPOINT_LOCAL;

  return {
    agregarDias,
    baseURL,
    capitalizarTexto,
    confirmAction,
    edate,
    formatoMoneda,
    numberFormat,
    obtenerFechaActual,
    porcentajeAValor,
    valorAPorcentaje,
    urlEndpoint,
  };
};

export default useUtil;
